import { WorkBook } from 'xlsx-js-style';
import { ExcelTemplate } from '../../interfaces';
import * as XLSX from 'xlsx-js-style';
import { CashFlow } from 'src/app/domain/company-performance/cash-flow/dto/CashFlow';
import { getPreparedData } from './mapping';
import { fitToColumn } from '../financial-statement/utils';
import { setColumnWidth, withHeaderStyling } from '../../utils';

export class CashFlowTemplate implements ExcelTemplate {
  export(data: CashFlow[]): WorkBook {
    const book = XLSX.utils.book_new();
    const sheet = this.getSheet(data);
    XLSX.utils.book_append_sheet(book, sheet);
    return book;
  }

  private getSheet(exportExcelData: CashFlow[]): XLSX.WorkSheet {
    const headers = this.getHeaders();
    const preparedData = getPreparedData(exportExcelData, headers);
    const sheet = {
      ...XLSX.utils.aoa_to_sheet(preparedData),
      '!cols': fitToColumn(preparedData),
    };
    const whiteSpaceIndexses = [0];
    whiteSpaceIndexses.forEach((index) => setColumnWidth(sheet, index, 34));
    return withHeaderStyling(sheet);
  }

  private getHeaders(): string[] {
    return ['Company', 'Transaction date', 'Amount', 'Transaction type', 'Round name', 'Comment'];
  }
}
